import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { FORM_GENERAL, PRIVACY_POLICY, TERMS } from "../../../../../constants/routes";

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
        <a href={FORM_GENERAL}>Contact</a>
        </li>
        <li>
          <Link target="_blank" to={PRIVACY_POLICY}>Privacy</Link>
        </li>
        <li>
          <Link target="_blank" to={TERMS}>Terms</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;